"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logDeprecationNote = void 0;
exports.logDeprecationNote = function (message) {
    if (process.env.NODE_ENV !== 'production') {
        console.warn("[DEPRECATION NOTE] " + message);
    }
};
//# sourceMappingURL=logDeprecationNote.js.map